// extracted by mini-css-extract-plugin
module.exports = {"reviewItemMobile":"n-ghX","reviewAvatar":"_2JtHo","reviewerDetails":"Adnq6","reviewDate":"_3EmZZ","replyLink":"_2mcZE","reviewDetails":"_1u087","reviewInModal":"kvm0X"};